import { Tooltip } from '@redis-ui/components';
import { InfoIcon } from '@redis-ui/icons';
import { HoverAbleInfoIconProps } from './HoverableInfoIcon.types';
import * as S from './HoverableInfoIcon.style';

const HoverableInfoIcon = ({
  tooltipContent,
  tooltipMaxWidth,
  size = 'L',
  iconDataTestId
}: HoverAbleInfoIconProps) => {
  return (
    <Tooltip
      maxWidth={tooltipMaxWidth}
      content={tooltipContent}
      interactive={typeof tooltipContent !== 'string'}
    >
      <S.Wrapper {...(iconDataTestId && { 'data-testid': iconDataTestId })}>
        <InfoIcon size={size} />
      </S.Wrapper>
    </Tooltip>
  );
};

export default HoverableInfoIcon;
